import React from "react";
import ReactSelect from "react-select";
import { COLORS } from "../../../constants";
import { FilterField } from "../types";

interface ModalSelectProps {
  field: FilterField;
  onFieldChange: (name: string, value: string) => void;
}

const ModalSelect: React.FC<ModalSelectProps> = ({ field, onFieldChange }) => {
  return (
    <ReactSelect
      options={field.options || []}
      placeholder={field.placeholder}
      isClearable
      value={
        field.options?.find(
          (option) => option.value.toString() === field.value
        ) || null
      }
      onChange={(option) =>
        onFieldChange(field.name, option?.value?.toString() || "")
      }
      styles={{
        control: (base) => ({
          ...base,
          borderColor: COLORS.NEUTRAL_300,
          "&:hover": {
            borderColor: COLORS.PRIMARY,
          },
          "&:focus-within": {
            borderColor: COLORS.PRIMARY,
            boxShadow: "0 0 0 2px rgba(147, 32, 24, 0.2)",
          },
        }),
      }}
    />
  );
};

export default ModalSelect;
